import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-lg);
`;

const StatusMessage = styled.p`
  font-size: 1.125rem;
  font-weight: 500;
  color: var(--color-text);
  margin-bottom: var(--spacing-sm);
`;

const Hint = styled.p`
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  margin-bottom: var(--spacing-md);
`;

const FileName = styled.span`
  font-weight: 500;
  color: var(--color-primary);
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: var(--color-border);
  border-radius: 4px;
  overflow: hidden;
  margin-top: var(--spacing-sm);
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${props => props.progress}%;
  background-color: var(--color-primary);
  border-radius: 4px;
  transition: width 0.3s ease;
`;

const ProcessingStatus = ({ status = 'processing', progress = 0, fileName }) => {
  const message = status === 'processing'
    ? 'Generating your subtitles...'
    : 'Please wait...';
  const hint = status === 'processing'
    ? 'This may take a minute depending on video length.'
    : 'Do not close this page.';

  return (
    <Wrapper>
      <StatusMessage>{message}</StatusMessage>
      <Hint>{hint}</Hint>
      {fileName && (
        <Hint>
          Processing: <FileName>{fileName}</FileName>
        </Hint>
      )}
      <ProgressBar>
        <ProgressFill progress={Math.min(progress, 99)} />
      </ProgressBar>
    </Wrapper>
  );
};

export default ProcessingStatus;
